import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getApplication(id) {
    return RetailerApiClient.get('applications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBaseApplication(id, salesChannelId) {
    return RetailerApiClient.get('base-application/' + id, {
      params: { sales_channel_id: salesChannelId }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  regeneratePin(parameters) {
    return RetailerApiClient.post('applications/findeks/regenerate-pin', parameters)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWaitingApplications() {
    return RetailerApiClient.get('waiting-applications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRejectedByOtherReasonApplications() {
    return RetailerApiClient.get('rejected-by-other-reason-applications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  transition(id, target_state) {
    return RetailerApiClient.post('applications/' + id + '/transition', {
      target_state: target_state
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelApplication(id, target_state, answers) {
    return RetailerApiClient.post('applications/' + id + '/cancel', {
      answers,
      target_state
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
